
























































































  import { Component, Vue } from 'vue-property-decorator'
  import yoy from './components/yoy.vue'
  import  NoData from '@/components/NoData'
  import moment from 'moment'
  import {getColors} from '@/utils'
  const echarts = require('echarts')
  import {getConsumptionRiseRequest,getConsumTrendRequest,getConsumptionRatioRequest,getTypeTrendRequest,getEntityTrendRequest} from '@/api/enerySupervision'

  @Component({
      components:{
          yoy,
          NoData
      }
  })
export default class Login  extends Vue {
  private colorArr:any=getColors()
  private year:any=moment(new Date().getFullYear(), 'YYYY')
  private yearShowOne:boolean=false
  private tiemDefaultValue:string='全年'
  private timeArr:any[]=[
      {value:'全年',id:`00`},
      {value:'一月',id:`01`},
      {value:'二月',id:`02`},
      {value:'三月',id:`03`},
      {value:'四月',id:`04`},
      {value:'五月',id:`05`},
      {value:'六月',id:`06`},
      {value:'七月',id:`07`},
      {value:'八月',id:`08`},
      {value:'九月',id:`09`},
      {value:'十月',id:`10`},
      {value:'十一月',id:`11`},
      {value:'十二月',id:`12`},
  ]
  private month:any='00'
  private newaarr:any[]=[]
  private unitType:number=0
  private code:any=null
  private action:string='view'
  private columns:any[] =[]
  private data=[]
  private riseObj:any={
      aboveNumber:0,
      belowNumber:0,
      rise:0,
      riseRate:0,
      aboveDate:0,
      // belowDate:0,
  }
  // 弹出日历和关闭日历的回调
  openChangeOne(status:any){
      if(status){
          this.yearShowOne =  true
      }else{
          this.yearShowOne =  false
      }
  }
  // 选择月份
  handleChange(value:any) {
      this.month=value
      if(moment(this.year).format('YYYY')=='Invalid date'){
          this.$message.error('年份不能为空')
      }else if(value=='00'){
          this.riseObj.aboveDate=`${moment(this.year).format('YYYY')}`
          this.riseObj.belowDate= `${Number(moment(this.year).format('YYYY'))-1}`
          const params={
              enterpriseCode:this.code,
              statDate: this.riseObj.aboveDate,
              unitType:this.unitType
          }
          this.init(params)
      }else{
          this.riseObj.aboveDate=`${moment(this.year).format('YYYY')}-${value}`
          this.riseObj.belowDate= `${Number(moment(this.year).format('YYYY'))-1}-${value}`
          const params={
              enterpriseCode:this.code,
              statDate: this.riseObj.aboveDate,
              unitType:this.unitType
          }
          this.init(params)
      }

  }
  // 得到年份选择器的值
  onYearChange(value:any){
      this.year = moment(value).format('YYYY')
              if(this.month=='00'){
              this.riseObj.aboveDate=this.year
              this.riseObj.belowDate=String(this.year-1)
          }else{
              this.riseObj.aboveDate=`${this.year}-${this.month}`
              this.riseObj.belowDate=`${this.year-1}-${this.month}`
          }
          const params={
              enterpriseCode:this.code,
              statDate: this.riseObj.aboveDate,
              unitType:this.unitType
          }
      this.init(params)
      this.yearShowOne = false
      // this.getUtilizationList(this.$route.query.code,this.year)
  }
  init(params:any){
      this.getConsumptionRise({enterpriseCode:params.enterpriseCode,statDate: params.statDate}) //综合能源消费量同比查询
      this.getConsumTrend(params) //综合能源消费量趋势查询
      this.getConsumptionRatio(params) //能源消费结构占比查询
      this.getTypeTrend({enterpriseCode:params.enterpriseCode,statDate: params.statDate}) //能源消费结构趋势查询
      this.getEntityTrend({enterpriseCode:params.enterpriseCode,statDate: params.statDate}) //能源实物消耗量趋势查询
  }
  //综合能源消费量同比查询
  async getConsumptionRise(params:any){
      try {
          const result=await getConsumptionRiseRequest(params)
          if(result.status==0 && result.data){
          this.riseObj.aboveNumber=result.data.aboveNumber
          this.riseObj.belowNumber=result.data.belowNumber
          this.riseObj.rise=result.data.rise
          this.riseObj.riseRate=result.data.riseRate
          }else{
          this.riseObj=null
          }
      } catch (err) {
          
      } 
  }
  private showConsumTrend:boolean= true
  //综合能源消费量趋势查询
  async getConsumTrend(params:any){
      try {
          const {status,data}=await getConsumTrendRequest(params)
          if(status==0&&data){
              const dataX:any=[]
              const dataY:any=[]
              data.forEach((ele:any) => {
                  dataX.push(ele.dateStr)
                  dataY.push(ele.dataValue)
              })
              this.initConsumption(dataX,dataY)
          }else{
              this.showConsumTrend= false
          }
      } catch (error) {
      
      }
      
  }
  //综合消耗走势图
  initConsumption(dataX:any,dataY:any) {
      setTimeout(function(){
           const main:any = document.getElementById('consumptionEchart')
      main.removeAttribute('_echarts_instance_')
      if(dataY.length === 0) {
      main.innerHTML = ''
      }
      // 基于准备好的dom，初始化echarts实例
      const consumptionEchart:any = echarts.init(main as HTMLDivElement)
      // 指定图表的配置项和数据
      const option = {
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'none',
                  crossStyle: {
                      color: '#999',
                      fontSize:12
                  }
              }
          },
          grid: {
              left: '20',
              top: '20',
              right: '20',
              bottom: '0',
              containLabel: true
          },
          xAxis: [{
              gridIndex: 0,
              type: 'category',
              data: dataX,
              axisPointer: {
                  type: 'shadow'
              },
              axisLine:{
                  lineStyle:{
                      color:'#ededff',
                      width:1
                  }
              },
              axisTick:{
              show:false
              },
              axisLabel: {
              color: '#999',
              fontSize: 12
              },
          }],
          yAxis: [{
              gridIndex: 0,
              type: 'value',
              min: 0,
              axisLine:{
              lineStyle:{
                  color:'#ededff',
                  width:1
              }
              },
              axisTick:{
              show:false
              },
              axisLabel: {
              color: '#999',
              fontSize: 12,
              formatter: '{value}'
              },
          }],
          series: [{
              name: '综合能源消费量',
              type: 'bar',
              barWidth : 20,//柱图宽度
              itemStyle: {
              normal: {
                                  color: new echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [
                          {offset: 1, color: '#d2e8fe'},                   //柱图渐变色
                          {offset: 0.5, color: '#7ebcfd'},                 //柱图渐变色
                          {offset: 0, color: '#3596fb'},                   //柱图渐变色
                      ]
                  ),
                  label:{
                      fontSize:9,
                      show:false,
                      position: 'top'
                  }
              }
              },   
              data: dataY
          }]
          }
      // 使用刚指定的配置项和数据显示图表。
      consumptionEchart.setOption(option)
      },1000)
  }
  private consumptionData: any= []
  getConsumptionRatio(params:any){
      getConsumptionRatioRequest(params).then((res: any)=>{
          const {status,data} =res
          if(status==0&&data&&data.length>0){
          this.consumptionData=data.map((ele:any)=>{
              return {
                  value:(ele.ratio*100).toFixed(2),
                  name:ele.energyName
              }
          })
          setTimeout(() => {
              this.initStructureEcharts( this.consumptionData)
          }, 300)
          
          }else{
              this.consumptionData=[]
              this.initStructureEcharts( this.consumptionData)
          }
      })
  }
  //综合能源消费结构占比
  initStructureEcharts(data:any){
      if(data.length>0){
          const that = this
          setTimeout(function(){
              const main = document.getElementById('structureEcharts')
              // 基于准备好的dom，初始化echarts实例
              const consumptionEchart:any = echarts.init(main as HTMLDivElement)
              const option = {
              textStyle:{
              color:'#fff'
              },
              color: that.colorArr, 
              tooltip: {
                  trigger: 'item',
                    formatter: '{b} : {c}%'
              },
              grid: {
              top:0,
              containLabel: true
              },
              legend: {
                  // orient: 'vertical',
                  icon: 'circle',
                  itemWidth: 10,  // 设置宽度
                  itemHeight: 10, // 设置高度
                  left: 'center',
                  bottom:0,
                  textStyle:{
                  color:'#999',
                  fontSize:12
                  },
                  // bottom: 'bottom',
              },
              series: [
              {
                  name: '能源消费结构占比',
                  type: 'pie',
                  clockwise:false,
                  roseType: 'radius',
                  radius: '60%',
                  center:['50%','45%'],
                  data: data,
                  itemStyle: {
                      normal: {
                          label: {        //此处为指示线文字
                              show: true,
                              // position: 'inner', //标签的位置
                              textStyle: {
                                  fontWeight: 200,
                                  fontSize: 13,    //文字的字体大小
                              
                              },
                              formatter:function (p:any) {   //指示线对应文字
                                  return p.name+Number(p.percent).toFixed(2) +'%'
                              },
                          },
                          labelLine: {    //指示线状态
                              show: true,
                              smooth: 0.2,
                              length: 10
                          }
                      }
                  },
                  emphasis: {
                      itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                      }
                  }
              }
              ],
              }
              consumptionEchart.setOption(option)
          },500)
      }
  }
  //用能单位能源消费结构趋势
  private showTrend: boolean=true
  async getTypeTrend(params:any){
      try {
      const {status,data}=await getTypeTrendRequest(params)
      if(status==0&&data.trendDataList.length>0){  
      let dataY=[]
      dataY=data.trendDataList.map((ele:any,index:number) => {
          return {
              name: data.energyNameList[index],
              type: 'line',
              data:ele
          }
      })
          this.initStructureTrendEcharts(data.energyNameList,data.timeList,dataY)
      }else{
          this.initStructureTrendEcharts(data.energyNameList,data.timeList,[])
      }
      } catch (error) {
      
      }
      
  }
  initStructureTrendEcharts(type:any,dataX:any,dataY:any){
      if(dataY.length>0){
          this.showTrend= true
          setTimeout(function(){
          const main:any = document.getElementById('structureTrendEcharts')
          main.removeAttribute('_echarts_instance_')
          // if(dataY.length === 0) {
          // main.innerHTML = ''
          // }
          // 基于准备好的dom，初始化echarts实例
          const consumptionEchart:any = echarts.init(main as HTMLDivElement)
          const option = {
              color: ['#4680f5', '#54b8b4', '#c17bfd','#ac5b6d','#fbeb63','#4fc971'], 
              tooltip: {
                  trigger: 'axis'
              },
              legend: {
                  top:0,
                  textStyle:{
                  color:'#999',
                  fontSize:12
                  },
              },
              grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
              },
              xAxis: {
                  type: 'category',
                  boundaryGap: false,
                      axisLine:{
                  lineStyle:{
                      color:'#ededff',
                      width:1
                  }
                  },
                  axisLabel: {
                  color: '#999',
                  fontSize: 12,
                  formatter: '{value}'
                  },
                  data: dataX
              },
              yAxis: {
                  type: 'value',
                      axisLine:{
                  lineStyle:{
                      color:'#ededff',
                      width:1
                  }
                  },
                  axisLabel: {
                  color: '#999',
                  fontSize: 12,
                  formatter: '{value}'
                  },
              },
          series:dataY
      }
          consumptionEchart.setOption(option)
          },1000)
      }else{
          this.showTrend= false
      }

  }

  //能源实物消耗量趋势查询
  private showEntityTrend:boolean=true
  async getEntityTrend(params:any){
      try{
          const {status,data} = await getEntityTrendRequest(params)
          if(status==0&&data.trendDataList.length>0){
              const datad=  data
              datad.energyNameList.unshift('时间')
              if(this.month=='00'){
                  datad.energyUnitList.unshift('月')
              }else{
                  datad.energyUnitList.unshift('日')
              }
              let dataY=[]
              dataY=datad.trendDataList.map((ele:any,index:number) => {
          
                  return {
                      name: datad.energyNameList[index+1],
                      type: 'line',
                      time:datad.timeList,
                      data:ele
                  }
              })

      this.columns=datad.energyNameList.map((ele:any,index:number)=>{
          return{
              title: ele+'('+datad.energyUnitList[index]+')',
              dataIndex:`name`+index
          }
      })
      const arrAll = [datad.timeList,...datad.trendDataList]
      const objArr = Array.from({length:datad.timeList.length},()=>{return {}}
      )
      objArr.forEach((ele:any,index)=>{
      datad.energyNameList.forEach((ite:any,k:any)=>{
          ele[`name${k}`] = arrAll[k][index]
          ele['id']=index
      })
      })
      this.newaarr=objArr
      this.showEntityTrend= true
      this.initEntityTrendEcharts(datad.energyNameList,datad.timeList,dataY)
      }else{
          this.showEntityTrend= false
      }
      }catch(error){

      }
  }

  initEntityTrendEcharts(type:any,dataX:any,dataY:any){
      setTimeout(function(){
          const main:any = document.getElementById('entityTrendEcharts')
          main.removeAttribute('_echarts_instance_')
          if(dataY.length === 0) {
              main.innerHTML = ''
          }
          // 基于准备好的dom，初始化echarts实例
          const consumptionEchart:any = echarts.init(main as HTMLDivElement)
          const option = {
              color: ['#4680f5', '#54b8b4', '#c17bfd','#ac5b6d','#fbeb63','#4fc971'], 
              tooltip: {
                  trigger: 'axis'
              },
              legend: {
                  top:0,
                  textStyle:{
                      color:'#999',
                      fontSize:12
                  },
              },
              grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
              },
              xAxis: {
                  type: 'category',
                  boundaryGap: false,
                      axisLine:{
                  lineStyle:{
                      color:'#ededff',
                      width:1
                  }
                  },
                  axisLabel: {
                  color: '#999',
                  fontSize: 12,
                  formatter: '{value}'
                  },
                  data: dataX
              },
              yAxis: {
                  type: 'value',
                      axisLine:{
                  lineStyle:{
                      color:'#ededff',
                      width:1
                  }
                  },
                  axisLabel: {
                  color: '#999',
                  fontSize: 12,
                  formatter: '{value}'
                  },
              },
          series:dataY
      }
          consumptionEchart.setOption(option)
      },1000)
  }
  created(){
      if(this.$route.query.code){
      this.code=this.$route.query.encode.toString()
      this.action=this.$route.query.action.toString()
      this.riseObj.aboveDate=this.$route.query.year
      this.riseObj.belowDate=String(this.riseObj.aboveDate-1)
      const params={
          enterpriseCode: this.code,
          unitType:0,
          statDate: this.riseObj.aboveDate,
      }
      
      this.init(params)
      }
  }
  mounted(){
      
  }
}
